"use strict";
import { __module as n } from "./index.es322.js";
var a;
function o() {
  return a ? n.exports : (a = 1, (function(f, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function d(l, t) {
      for (var u in t) Object.defineProperty(l, u, {
        enumerable: !0,
        get: t[u]
      });
    }
    d(e, {
      cancelIdleCallback: function() {
        return c;
      },
      requestIdleCallback: function() {
        return r;
      }
    });
    const r = typeof self < "u" && self.requestIdleCallback && self.requestIdleCallback.bind(window) || function(l) {
      let t = Date.now();
      return self.setTimeout(function() {
        l({
          didTimeout: !1,
          timeRemaining: function() {
            return Math.max(0, 50 - (Date.now() - t));
          }
        });
      }, 1);
    }, c = typeof self < "u" && self.cancelIdleCallback && self.cancelIdleCallback.bind(window) || function(l) {
      return clearTimeout(l);
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), f.exports = e.default);
  })(n, n.exports), n.exports);
}
export {
  o as __require
};
//# sourceMappingURL=index.es289.js.map
